import React from 'react';
import { ReactComponent as TooltipIcon } from 'resources/images/info.svg';
import {
  Flex,
  Tooltip,
  TextProps,
  Heading,
  FlexProps,
  Icon,
} from '@chakra-ui/react';

interface FormSubtitleProps extends TextProps {
  tooltip?: string;
  containerClassname?: string;
  containerStyleProps?: FlexProps; // TODO remove this when migrated all components to chakra UI
}

export const FormSubtitle: React.FC<FormSubtitleProps> = ({
  children,
  className,
  tooltip,
  containerClassname,
  containerStyleProps,
  ...props
}) => (
  <Flex
    className={containerClassname}
    alignItems="center"
    {...containerStyleProps}
  >
    <Heading
      as="h6"
      className={className}
      color="textBase"
      itemType=""
      fontWeight={500}
      fontSize="sm"
      lineHeight="19px"
      {...props}
    >
      {children}
    </Heading>
    {tooltip && (
      <Tooltip label={tooltip}>
        <Icon
          as={TooltipIcon}
          cursor="pointer"
          color="iconBase"
          w={4}
          h={4}
          data-testid="tooltip-icon"
          ml={1}
        />
      </Tooltip>
    )}
  </Flex>
);
